import { preloadHeroImage } from "../utils/lcpHero";

export { preloadHeroImage, dismissLcpHeroShell, dismissLcpHeaderShell, isLcpHeroShellVisible } from "../utils/lcpHero";

const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;

function parseFirestoreValue(value) {
  if (!value || typeof value !== "object") return null;
  if ("stringValue" in value) return value.stringValue;
  if ("booleanValue" in value) return value.booleanValue;
  if ("integerValue" in value) return parseInt(value.integerValue, 10);
  if ("doubleValue" in value) return value.doubleValue;
  if ("nullValue" in value) return null;
  if ("arrayValue" in value) {
    return (value.arrayValue.values || []).map((item) => parseFirestoreValue(item));
  }
  if ("mapValue" in value) {
    const obj = {};
    const fields = value.mapValue.fields || {};
    for (const [key, fieldValue] of Object.entries(fields)) {
      obj[key] = parseFirestoreValue(fieldValue);
    }
    return obj;
  }
  return null;
}

function parseFirestoreDocument(doc) {
  const id = doc.name.split("/").pop();
  const data = {};
  const fields = doc.fields || {};
  for (const [key, value] of Object.entries(fields)) {
    data[key] = parseFirestoreValue(value);
  }
  return { id, ...data };
}

async function fetchCollection(collectionId) {
  if (!PROJECT_ID) {
    throw new Error("Missing REACT_APP_PROJECT_ID");
  }

  const url = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/${collectionId}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Firestore REST ${response.status}`);
  }

  const json = await response.json();
  if (!json.documents) return [];
  return json.documents.map(parseFirestoreDocument);
}

async function fetchDocument(collectionId, documentId) {
  if (!PROJECT_ID) {
    throw new Error("Missing REACT_APP_PROJECT_ID");
  }

  const url = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/${collectionId}/${documentId}`;
  const response = await fetch(url);

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`Firestore REST ${response.status}`);
  }

  const json = await response.json();
  return parseFirestoreDocument(json);
}

export function fetchSliders() {
  return fetchCollection("sliders-jeep");
}

export async function fetchFinanciaciones() {
  const doc = await fetchDocument("financiaciones", "datos");
  return doc?.datos || [];
}

export function getFirstBannerUrl(banners, isDesktop = true) {
  const doc = banners[0];
  if (!doc) return null;
  const items = isDesktop ? doc.desktop : doc.mobile;
  return items?.[0]?.slider || null;
}


export function preloadSlidersEarly() {
  if (typeof window === "undefined") return;

  const envHeroUrl = process.env.REACT_APP_HERO_PRELOAD_URL;
  if (envHeroUrl) {
    preloadHeroImage(envHeroUrl);
  }

  const isDesktop = window.matchMedia("(min-width: 768px)").matches;

  try {
    const cached = sessionStorage.getItem("sliders-jeep");
    if (cached) {
      preloadHeroImage(getFirstBannerUrl(JSON.parse(cached), isDesktop));
      return;
    }
  } catch {
    /* noop */
  }

  fetchSliders()
    .then((banners) => {
      if (!banners.length) return;
      sessionStorage.setItem("sliders-jeep", JSON.stringify(banners));
      preloadHeroImage(getFirstBannerUrl(banners, isDesktop));
    })
    .catch(() => {});
}
